export default __webpack_public_path__ + "static/media/todo-screenshot-03.9687c7ce.png";